import styled from 'styled-components'

type Props = {
	isVisible: boolean
}

export const LoaderWrapper = styled.div<Props>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

	transition: opacity 0.4s;
`
